export default __webpack_public_path__ + "static/media/ISKO CLASS 10 SYLLABUS.8014d8e1.pdf";